import React, {Component}   from 'react';
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import ColAtm from "../../../atomic/Col/Col";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import {Animated} from "react-animated-css";
import PaymentBookingList from "./PaymentBookingList";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {PAYMENT} from "../../../../constants/appUrls.constants";
import {connect} from "react-redux";
import {getPaymentTransactionList} from "../../../../redux/actions/Payment/PaymentTransaction.actions";
import moment from 'moment/moment';
import {ValidatorForm, SelectValidator, TextValidator} from "react-material-ui-form-validator";
import BlockAtm from "../../../atomic/Block/Block";
import ButtonAtm from "../../../atomic/Button/Button";
import {Hidden, MenuItem} from "@material-ui/core";
import {
    DateRangePicker,
} from "react-dates";
import { PAYMENT_TRANSACTION_LIST } from '../../../../constants/api.constants';
import { getProperty } from '../../../../utils';
import axios from 'axios';
import { getAppLang } from '../../../../utils';
import CircularProgress from '@material-ui/core/CircularProgress';

let t =null;
let fromRange = '29/03/2020';
const appLanguage = localStorage.getItem("lng");
moment.locale(appLanguage)

class TransactionList extends Component {
    constructor(props) {
        super(props);
        t = props.t;
        this.state = {
            startDate: null,
            endDate: null,
            dateRange: '',
            focusedInput: '',
            transactionCode: '',
            orderCode: '',
            paymentStatus: null,
            filteredTableData: null,
            clearFilters: false,
            isLoading: false
        }
    }

    isOutsideRange = (day => {
        let dayIsBlocked = false;
        if(day > moment(fromRange)) {
            dayIsBlocked = true;
        }
        return dayIsBlocked;
    })

    componentDidMount() {

        this.props.getPaymentTransactionList();
    }

    syncFilter = (transaction_code, order_code,status, date_range) => {
        this.setState({isLoading: true});
        const params = {
            params: {
              property_id: getProperty(),
              filter:{
                code: transaction_code === '' ? null : transaction_code,
                order_id: order_code === '' ? null : order_code,
                status: status,
                // date_range: date_range === '' ? "2021-01-01 " + moment().format('YYYY-MM-DD') : date_range
                date_range: date_range === '' ? null : date_range
              }
            }
          }
          axios.post(PAYMENT_TRANSACTION_LIST, params, {
            headers: {
              "Accept": "application/json",
              authToken: localStorage.getItem('auth'),
              "Content-Type": "application/json",
              "language": getAppLang(),
            }
          }).then((result) => {
            this.setState({isLoading: false});
            this.setState({filteredTableData: result.data.data});
            this.setState({clearFilters: true});
          }).catch(function (error) {
            console.log(error);
            this.setState({isLoading: false});
          });

    }

    onSubmit = (e) => {
        e.preventDefault();
        this.syncFilter(this.state.transactionCode, this.state.orderCode, this.state.paymentStatus, this.state.dateRange);
    }

    clearAllFilters = (e) => {
        this.setState({filteredTableData:null});
        this.setState({clearFilters: false});

        this.setState({orderCode:''});
        this.setState({transactionCode:''});
        this.setState({paymentStatus:null});

        this.setState({startDate:null});
        this.setState({endDate:null});
        this.setState({dateRange:''});
    }

    orderId = (e) => {
        this.setState({orderCode: e.target.value});
    }

    transactionCode = (e) => {
        this.setState({transactionCode: e.target.value});
    }

    paymentStatus = (e) => {
        this.setState({paymentStatus: e.target.value});
    }

    onFocusChange = (focusedInput) => {
        this.setState({focusedInput});
    }

    render() {
        const {focusedInput, startDate, endDate, orderCode, transactionCode, paymentStatus, filteredTableData, clearFilters, isLoading, dateRange} = this.state;
        return (
            <>
                <PageTitle title={ t('enw-payment-transaction_list-page_title') } />
                <PageHeaderAtm exitText={ t('btn-dashboard') } backButton={PAYMENT} text={ t('enw-payment-transaction_list-page_title') } />
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="container-width pb-0">
                        <ValidatorForm onSubmit={this.onSubmit}  className="reservation-filter-container payment-datepicker pos-relative w-100 pt-4 p-24">
                            <ColAtm spacing={3}>
                            <BlockAtm item xs={6} md={3}>
                                <TextValidator
                                    onChange={(e) => this.orderId(e)}
                                    className="form-control w-100"
                                    variant="outlined"
                                    fullWidth
                                    label={ t('enw-reservation-detail-order_id') }
                                    value={orderCode === null ? '' : orderCode}
                                />
                            </BlockAtm>
                            <BlockAtm item xs={6} md={3}>
                                <TextValidator
                                    onChange={(e) => this.transactionCode(e)}
                                    className="form-control w-100"
                                    variant="outlined"
                                    fullWidth
                                    label={ t('enw-reservation-detail-transaction_code') }
                                    value={transactionCode === null ? '' : transactionCode}
                                />
                            </BlockAtm>
                            <BlockAtm item xs={12} md={2}>
                                <SelectValidator
                                    onChange={(e) => this.paymentStatus(e)}
                                    className="form-control w-100 mt-0-mb"
                                    variant="outlined"
                                    fullWidth
                                    label={ t('enw-input-status') }
                                    value={paymentStatus === null ? '' : paymentStatus}
                                >
                                    <MenuItem value={0}>{ t('enw-payment_transaction-status-error') }</MenuItem>
                                    <MenuItem value={1}>{ t('enw-payment_transaction-status-success') }</MenuItem>
                                    <MenuItem value={2}>{ t('enw-payment_transaction-status-start') }</MenuItem>
                                    <MenuItem value={3}>{ t('enw-payment_transaction-status-pending') }</MenuItem>
                                    <MenuItem value={4}>{ t('enw-payment_transaction-status-cancel_refund') }</MenuItem>
                                    <MenuItem value={5}>{ t('enw-payment_transaction-status-payment_link') }</MenuItem>
                                </SelectValidator>
                            </BlockAtm>
                            <BlockAtm item xs={12} md={3} className="align-self-end">
                                <Hidden smUp>
                                    <DateRangePicker
                                        startDateId="1"
                                        endDateId="1"
                                        startDate={startDate}
                                        endDate={endDate}
                                        onDatesChange={({ startDate, endDate }) => {
                                            this.setState({startDate:startDate});
                                            this.setState({endDate:endDate});
                                            this.setState({dateRange: moment(startDate).format('YYYY-MM-DD') + " " + moment(endDate).format('YYYY-MM-DD')})
                                        }}
                                        focusedInput={focusedInput}
                                        onFocusChange={this.onFocusChange}
                                        isOutsideRange={this.isOutsideRange}
                                        initialVisibleMonth={() => moment().subtract(1, "month")}
                                        orientation={"horizontal"}
                                        numberOfMonths={1}
                                        minimumNights={0}
                                        startDatePlaceholderText={ t('enw-input-start_date') }
                                        endDatePlaceholderText={ t('enw-input-end_date') }
                                        displayFormat="DD-MM-YYYY"
                                    />
                                </Hidden>
                                <Hidden xsDown>
                                    <DateRangePicker
                                        startDateId="1"
                                        endDateId="1"
                                        startDate={startDate}
                                        endDate={endDate}
                                        onDatesChange={({ startDate, endDate }) => {
                                            this.setState({startDate:startDate});
                                            this.setState({endDate:endDate});
                                            this.setState({dateRange: moment(startDate).format('YYYY-MM-DD') + " " + moment(endDate).format('YYYY-MM-DD')})
                                        }}
                                        focusedInput={focusedInput}
                                        onFocusChange={this.onFocusChange}
                                        isOutsideRange={this.isOutsideRange}
                                        initialVisibleMonth={() => moment().subtract(1, "month")}
                                        orientation={"horizontal"}
                                        minimumNights={0}
                                        startDatePlaceholderText={ t('enw-input-start_date') }
                                        endDatePlaceholderText={ t('enw-input-end_date') }
                                        displayFormat="DD-MM-YYYY"
                                    />
                                </Hidden>
                            </BlockAtm>
                            <BlockAtm item xs={12} md={1} className="align-self-center mt-20">
                                <ButtonAtm
                                    type="submit"
                                    buttontext={ t('enw-table-toolbar-filters') }
                                    className="reservation-filter-btn bg-red"
                                    disabled={orderCode === '' && transactionCode === '' && paymentStatus === null && dateRange === '' || dateRange.includes('Invalid date') ? true : false}
                                />
                            </BlockAtm>
                                {
                                    clearFilters &&
                                    <ButtonAtm className="clear-filter-btn" startIcon={<i className="fas fa-times" />} onClick={this.clearAllFilters} />
                                }
                            </ColAtm>
                        </ValidatorForm>
                            <ColAtm className="booking-list transaction-col">
                                {
                                    isLoading ?
                                        <CircularProgress className='loading-spinner' style={{left:"40%", color: "#d71f26", width: "50px", height: "50px", top: "100%"}} />
                                    :
                                    !this.props.transactionListData.fetching &&
                                    this.props.transactionListData.transactionList &&
                                    <PaymentBookingList filteredData={filteredTableData} reservationList = {filteredTableData !== null ? filteredTableData : this.props.transactionListData.transactionList}/>
                                }
                            </ColAtm>
                        </div>
                    </Container>
                </Animated>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return{
        transactionListData : state.paymentTransactionReducer
    }
};

const mapDispatchToProps = {
    getPaymentTransactionList
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(TransactionList));
